export const AppRoutes = {
  beststories: '/',
  topstories: '/topstories',
  skippedStories: '/skippedStories',
}
